import {
  BasicDisplayUnits,
  UnitBase,
  additionalUnitLabels,
  convertIfRequired,
  getAbbreviation,
  unitLabels
} from 'hooks/useDisplayUnits/useDisplayUnits';
import { i18n } from 'i18n';
import { round } from 'lodash';
import {
 CustomUnitFields,
 DisplayUnits,
 ThroughputControlType,
 UnitSystem
} from 'providers/api';

export const unitString = (unitSystem: UnitSystem, unitInfo: UnitBase, customUnitFields: CustomUnitFields[], value?: number) => {
  if (!value) return i18n._('no data');
  const convertedValue = round(convertIfRequired(value, unitSystem, unitInfo, customUnitFields), 2);
  const abbreviation = getAbbreviation(unitInfo, unitSystem, customUnitFields);
  return `${convertedValue} ${abbreviation}`;
};

export const throughputUnitLabelFromThroughputControlType = (throughputControlType: ThroughputControlType) => {
  let unitLabel;
  switch (throughputControlType) {
    case ThroughputControlType.WetTonnage:
      unitLabel = unitLabels[BasicDisplayUnits.WetTonnage];
      break;
    case ThroughputControlType.FlowRate:
      unitLabel = additionalUnitLabels[DisplayUnits.FlowRate];
      break;
    default:
      unitLabel = unitLabels[BasicDisplayUnits.DryTonnage];
      break;
  }
  return unitLabel;
};

export const displayThroughput = (
  unitSystemPreference: UnitSystem,
  throughputControlType: ThroughputControlType,
  customUnitFields: CustomUnitFields[],
  throughput?: number,
) => unitString(unitSystemPreference, throughputUnitLabelFromThroughputControlType(throughputControlType), customUnitFields, throughput);
